import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import {
  initState,
  selectRequestState,
  selectDynamicQueryParams,
  selectVisibleQueryParams,
  changeQueryParams,
  sendRequest,
  selectItemsIds,
  selectItemById,
  selectPagination
} from 'mt-react-common/common/reducers/list/reducer';
import connect from 'react-redux/es/connect/connect';
import qs from 'qs';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default function createGroupItem(WrappedComponent) {
  class GroupsSearchItem extends Component {
    constructor(props) {
      super(props);
      this.props.initState();
      this.props.changeQueryParams(this.getLocationSearchParams(this.props));
      // Вешаем слушител на действия пользователя по смене истории браузера
      window.addEventListener('popstate', this.onPopstate);
    }

    /**
     * Если состояние запроса reduce list перешло в inProgress вызываем функцию setLocationSearch чтобы актуализировать
     * location.search если это требуется
     */
    componentDidUpdate(prevProps) {
      if (
        this.props.requestState.inProgress !==
          prevProps.requestState.inProgress &&
        this.props.requestState.inProgress
      ) {
        this.setLocationSearch(prevProps);
      }
      if (
        !_.isEqual(
          this.getLocationSearchParams(this.props),
          this.getLocationSearchParams(prevProps)
        ) &&
        _.isEmpty(this.getLocationSearchParams(this.props))
      ) {
        this.handleChangeQueryParamsFromLocationSearch();
      }
    }

    // Удаляем слушителя события popstate, тк при повторной инициализации компонента шлушатели будут размножаться.
    componentWillUnmount() {
      window.removeEventListener('popstate', this.onPopstate);
    }

    onPopstate = () => {
      this.handleChangeQueryParamsFromLocationSearch();
    };

    /**
     * Если динамические параметры запроса есть в store и текущий набор параметров из location.search не равен
     * видимым параметрам запроса в store то присваеваем их к location.search текущего дочернего компонента
     */
    setLocationSearch = prevProps => {
      if (
        (!_.isEmpty(this.props.selectDynamicQueryParams) &&
          !_.isEqual(
            this.props.selectVisibleQueryParams,
            this.getLocationSearchParams(this.props)
          )) ||
        (_.isEmpty(this.props.selectDynamicQueryParams) &&
          !_.isEmpty(prevProps.selectDynamicQueryParams) &&
          !_.isEmpty(this.getLocationSearchParams(this.props)))
      ) {
        this.props.setGroupQueryParamsAndUpdateHistory({
          [this.props.groupName]: this.props.selectVisibleQueryParams
        });
      }
    };

    /**
     * Получение набора location.search для текущего дочернего компонента
     */
    getLocationSearchParams = props =>
      qs.parse(props.location.search.slice(1))[props.groupName] || {};

    /**
     * Устанавливает параметры текущей группы в changeQueryParams из location.search и выполянет запроос к серверу
     */
    handleChangeQueryParamsFromLocationSearch = () => {
      // Присваеваем параметры запроса из search url. и вызываем запрос
      this.props.changeQueryParams(this.getLocationSearchParams(this.props));
      this.props.sendRequest();
    };

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  GroupsSearchItem.displayName = `GroupsSearchItem(${getDisplayName(
    WrappedComponent
  )})`;

  GroupsSearchItem.propTypes = {
    // IN
    listReduceName: PropTypes.string.isRequired,
    groupName: PropTypes.string.isRequired,
    setGroupQueryParamsAndUpdateHistory: PropTypes.func.isRequired,

    // CONNECT
    initState: PropTypes.func.isRequired,
    sendRequest: PropTypes.func.isRequired,
    changeQueryParams: PropTypes.func.isRequired,
    selectDynamicQueryParams: PropTypes.shape({}).isRequired,
    selectVisibleQueryParams: PropTypes.shape({}).isRequired,
    requestState: PropTypes.shape({
      inProgress: PropTypes.bool.isRequired
    }).isRequired,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
      pathname: PropTypes.string.isRequired
    }).isRequired
  };

  GroupsSearchItem.contextTypes = {
    router: PropTypes.shape()
  };

  const mapStateToProps = (state, props) => ({
    requestState: selectRequestState(state, props.listReduceName),
    selectDynamicQueryParams: selectDynamicQueryParams(
      state,
      props.listReduceName
    ),
    selectVisibleQueryParams: selectVisibleQueryParams(
      state,
      props.listReduceName
    ),
    itemsIds: selectItemsIds(state, props.listReduceName),
    selectItemById: id => selectItemById(state, props.listReduceName, id),
    pagination: selectPagination(state, props.listReduceName)
  });

  const mapDispatchToProps = (dispatch, props) => ({
    initState: bool => dispatch(initState(props.listReduceName, bool)),
    sendRequest: () => dispatch(sendRequest(props.listReduceName)),
    changeQueryParams: queryParams =>
      dispatch(changeQueryParams(props.listReduceName, queryParams))
  });

  return withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(GroupsSearchItem)
  );
}



// WEBPACK FOOTER //
// ./src/components/Hocs/GroupsSearchCollector/GroupsSearchItem.js